export default __webpack_public_path__ + "static/media/matching-profiles-container.bb454363.svg";